export default from './ProjectSpecifications';



// WEBPACK FOOTER //
// ./src/containers/ProjectSpecifications/index.js